import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[settingsHost]',
  standalone: true
})
export class SettingsDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
